export const admin_sidebar = [
  {
    id: 0,
    name: "Dashboard",
    Icon: "fa-regular fa-grid-2",
    route: "/admin/dashboard",
    Data: [],
  },
  {
    id: 1,
    name: "Clients",
    Icon: "fas fa-users-viewfinder",
    route: "/admin/allclients",
    Data: [],
  },
  {
    id: 2,
    Icon: "fas fa-users-cog",
    name: "Sub Admins",
    route: "/admin/allsubadmins",
  },
  // {
  //   id: 3,
  //   name: "Orders",
  //   route: "/admin/order",
  //   Icon: "fas fa-bell",
  // },
  {
    id: 4,
    name: "All Orders",
    route: "/admin/orders",
    Icon: "fas fa-bell",
  },
  // {
  //   id: 5,
  //   name: "Open Position",
  //   route: "/admin/openposition",
  //   Icon: "fas fa-briefcase",
  // },
  // {
  //   id: 6,
  //   name: "Close Position",
  //   route: "/admin/closeposition",
  //   Icon: "fas fa-lock",
  // },
  {
    id: 6,
    name: "Trade History",
    route: "/admin/tradehistory",
    Icon: "fas fa-lock",
  },
  {
    id: 7,
    name: "Strategies",
    route: "/admin/strategies",
    Icon: "fas fa-chess-knight",
    Data: [],
  },
  {
    id: 8,
    name: "All Stocks",
    route: "/admin/allservices",
    Icon: "fas fa-list",
  },
  {
    id: 9,
    name: "Stock Group Services",
    route: "/admin/groupservices",
    Icon: "fas fa-layer-group",
  },
  {
    id: 10,
    name: "Active Services",
    route: "/admin/allLicence",
    Icon: "fas fa-file-shield",
  },
  {
    id: 11,
    name: "Connect Your Broker",
    route: "/admin/apicreateinfo",
    Icon: "fas fa-code-branch",
  },
  // {
  //   id: 12,
  //   name: "Help Desk",
  //   route: "/admin/helpcenter",
  //   Icon: "fas fa-life-ring",
  // },
  {
    id: 13,
    name: "Message Broadcast",
    route: "/admin/msgbroadcast",
    Icon: "fas fa-paper-plane",
  },
  {
    id: 14,
    name: "Trade Monitoring",
    route: "/admin/trademonitoring",
     Icon: "fas fa-chart-bar",
  },
  {
    id: 15,
    name: "Trade",
    route: "/admin/trade",
    Icon: "fas fa-chart-line",
  },
  // {
  //   id: 15,
  //   name: "FAQ",
  //   route: "/admin/faq",
  //   Icon: "fas fa-question-circle",
  // },
  {
    id: 16,
    name :"trade Calculation",
    route : "/admin/tradecalculation",
    Icon : "fas fa-calculator",
    
  }
];

export const Client = [
  {
    id: 0,
    name: "Dashboard",
    Icon: "fa-regular fa-grid-2",
    route: "/client/dashboard",
    Data: [],
  },
  {
    id: 1,
    // name: "Stocks",
    name: "Crypto",
    Icon: "fa-solid fa-chart-column",
    route: "/client/stocks",
    Data: [],
  },
  {
    id: 2,
    name: "Signals",
    Icon: "fas fa-wave-square",
    route: "/client/signals",
    Data: [],
  },
  {
    id: 3,
    name: "Trade History",
    Icon: "fas fa-history",
    route: "/client/tradehistory",
    Data: [],
  },
  {
    id: 4,
    name: "Trading Status",
    Icon: "fas fa-chart-line",
    route: "/client/tradingstatus",
    Data: [],
  },
  {
    id: 5,
    name: "Broker Response",
    Icon: "fas fa-random",
    route: "/client/brokerresponse",
    Data: [],
  },
  {
    id: 6,
    name: "Connect Your Broker",
    Icon: "fas fa-wallet",
    route: "/client/apicreateinfo",
    Data: [],
  },
  {
    id: 7,
    name: "Help Center",
    Icon: "fas fa-life-ring",
    route: "/client/helpcenter",
    Data: [],
  },
  {
    id: 8,
    name: "Wallet",
    Icon: "fas fa-wallet",
    route: "/client/wallet",
    Data: [],
  },
  {
    id: 9,
    name: "Tutorials & Guides",
    Icon: "fas fa-book-open",
    route: "/client/tutorials",
    Data: [],
  },
  {
    id: 10,
    name: "Backtesting",
    Icon: "fas fa-chart-line",
    route: "/client/backtesting",
    Data: [],
  },
  {
    id: 11,
    name: "FAQ",
    Icon: "fas fa-info-circle",
    route: "/client/faq",
    Data: [],
  },
  {
    id: 12,
    name : "Calculation",
    Icon : "fas fa-calculator",
    route : "/client/calculation",
    Data : [],
  }
];

export const supper_admin_sidebar = [
  {
    id: 0,
    name: "Dashboard",
    Icon: "fa-regular fa-grid-2",
    route: "/super/dashboard",
    Data: [],
  },
  {
    id: 1,
    name: "All Admins",
    Icon: "fas fa-users-cog me-3",
    route: "/super/alladmins",
    Data: [],
  },
  {
    id: 2,
    name: "All Permissions",
    Icon: "fas fa-shield-alt",
    route: "/super/permitions",
    Data: [],
  },
  {
    id: 3,
    name: "History",
    Icon: "fas fa-history",
    route: "/super/history",
    Data: [],
  },
  {
    id: 4,
    name: "Faq",
    Icon: "fas fa-info-circle",
    route: "/super/update/faq",
    Data: [],
  },
  {
    id: 5,
    name: "Broker Details",
    Icon: "fas fa-briefcase",
    route: "/super/brokerdetails",
    Data: [],
  },
];

export const sub_admin_sidebar = [
  {
    id: 0,
    name: "Dashboard",
    Icon: "fa-regular fa-grid-2",
    route: "/subadmin/dashboard",
    Data: [],
  },
  {
    id: 1,
    name: "Signals",
    Icon: "fas fa-signal text-success",
    route: "/subadmin/signals",
    Data: [],
    sidebar: "Signals"
  },
  {
    id: 2,
    name: "All Clients",
    Icon: "fas fa-users-viewfinder",
    route: "/subadmin/clients",
    Data: [],
  },

  {
    id: 4,
    name: "Api Create Info",
    Icon: "fas fa-code",
    route: "/subadmin/apicreateinfo",
    Data: [],
  },
  {
    id: 5,
    name: "Strategies",
    route: "/subadmin/strategies",
    Icon: "fas fa-chess-knight",
    Data: [],
  },
  {
    id: 6,
    name: "Stock Group Services",
    route: "/subadmin/groupservices",
    Icon: "fas fa-layer-group",
  },
   {
    id: 7,
    name: "Trade",
    route: "/subadmin/trade",
    Icon: "fas fa-layer-group",
  },

  {
    id: 9,
    name: "Trade History",
    Icon: "fas fa-history",
    route: "/subadmin/TradeHistory",
    Data: [],
  },
  {
    id: 10,
    name: "Trade Calculation",
    Icon: "fas fa-calculator",
    route: "/subadmin/tradeCcalculation",
    Data: [],
  },
  
];